<!-- header search & filters -->
<section class="home-advance-search" [ngClass]="{ '!mt-6': wFull() }">
  <!-- header search input -->

  <form
    class="home-advance-search__fields-container"
    [formGroup]="searchForm"
    (submit)="submitSearchForm()">
    <pwj-input
      placeholder="global.search"
      class="home-advance-search__search-field"
      type="text"
      variant="default"
      [ngClass]="{ '!w-full': wFull() }"
      formControlName="searchTerm"></pwj-input>
    <button class="home-advance-search__search-btn" type="submit">
      <i class="iconsax search-icon" icon-name="search-normal-2"></i>
    </button>
  </form>
  <!-- advanced search actions are temporary disabled -->
</section>
